import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../../../Component/Model/helpers';

export const deviationSchema = yup.object({
	reasonId: yup
		.number()
		.nullable()
		.transform((value, originalValue) => {
			return originalValue === '' ? null : value;
		})
		.required('Justifiable Reason is required')
		.typeError('Justifiable Reason is required'),
	eEA2KeyJustifiableReason: yup.boolean().nullable(),
	comment: yup
		.string()
		.nullable()
		.required('Comment is required')
		.test('commentLengthTest', `Comment is too long (Max length is 6000 characters)`, (value) => {
			if (!value) {
				return true;
			}
			return DataTableHtmlFormatter(value, '').length <= 6000;
		}),
	remedialPlan: yup
		.string()
		.nullable()
		.test('remedialPlanLengthTest', `Remedial Plan is too long (Max length is 1000 characters)`, (value) => {
			if (!value) {
				return true;
			}
			return DataTableHtmlFormatter(value, '').length <= 1000;
		})
});
